import { getAPI } from "./axios-base";

export default class RestResourceTruck {
  getTrucks(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/truck", {
      params: params
    });
  }
  postTruck(body: any) {
    return getAPI.post("api/rest/v1/truck", body);
  }
  getTruck(id: string) {
    return getAPI.get(`api/rest/v1/truck/${id}`);
  }
  putTruck(id: string, body: any) {
    return getAPI.put(`api/rest/v1/truck/${id}`, body);
  }
  uploadFiles(truck: any) {
    const formdata = new FormData();
    formdata.append("truckId", truck._id);
    if (truck.files) {
      console.log(truck.files);
      truck.files.forEach((p: string | Blob, i: any) => {
        formdata.append(`files[${i}]`, p);
      });
    }
    return getAPI.post("api/rest/v1/truck/upload-pictures", formdata, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  getPicture(id: string, picture: string) {
    return getAPI.get(`api/rest/v1/minio/media/${picture}?truckId=${id}`);
  }
}
